const getUploadData = (item, file) => {
  const computedItem = item?._id || item?.uid
  const computedFile = file?._id || file?.uid
  const includesElements = computedItem && computedFile

  return [computedItem, computedFile, includesElements]
}

export default getUploadData
